class connection {
	constructor(info){
		this.url 		= "";
		this.api 		= info.api;
		this.settings 	= info.setting;
		this.ml 		= null;
		this.EventBus 	= info.EventBus;
		this.format 	= info.format;
		this.store  	= info.store;
		this.helper 	= info.helper;
		this.info 		= info;
		this.sockets  	= {};
	}

	update_list(key, item){
		if (key && this[key]) {
			this[key] = item;
		}else{
			if (typeof key == "string") this.info[key] = item;			
		}
	}
	set_workspace({ url, workspace_, key}){
		// console.log("************** SET workspace : ", url, workspace_, key)
		if (this.sockets && !this.sockets[key]) {
			this.sockets[key] = {};
		}
		if (url) {
			this.sockets[key].url = url; 
		}else{
			let { protocol_socket, ip_socket, port_socket, workspace } = this.api;
			let workspace_end 		= workspace_ == "statistics" ? workspace_ : `${workspace}-${workspace_}`; 
			this.sockets[key].url 	= `${protocol_socket + ip_socket}:${port_socket}/${workspace_end}`;
			// console.log("URL =========== ", this.sockets[key].url)

		}	
		this.init({ key, });
	}


}

export default connection;